import { CaseInfoFile } from './type';

const initPatient = {
    name: '',
};
/**
 * @type {CaseInfoFile[]}
 */
const intiFiles = [];

export default class CaseInfo {
    constructor(data, platform) {
        this.dateUpdated = data.dateUpdated || null;
        this.dateCreated = data.dateCreated || null;
        this.dateScanned = data.dateScanned || null;
        // case's uuid
        this.uuid = data.uuid || '';
        this.name = data.name || '';
        this.status = data.status || '';
        // this.tags = data.tags || []
        this.patient = data.patient || initPatient;
        /**
         * @type {CaseInfoFile[]}
         */
        this.files = data.files || intiFiles;
        this.platform = platform || null;
    }
}
